<template>
  <div>
    <div class="right-title">
      <span>创建实习双选会</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="bannet-list-box" style="padding-top: 50px;">
        <div class="banner-item">
          <div class="item">
            <span class="left-label">实习双选会名称</span>
            <el-input v-model="name" placeholder="请输入实习双选会名称" style="width: 960px;"></el-input>
          </div>
          <div class="item">
            <span class="left-label">实习双选会简介</span>
            <div style="width: 960px;height: 450px;">
              <quill class="quill" @getData="getData"></quill>
            </div>

          </div>
<!--          <p style="text-align: right;color: #999;max-width: 1100px;margin-bottom:20px;">{{desc.length}}/800字</p>-->
          <div class="item">
            <span class="left-label">实习双选会PC海报<br/>图片建议尺寸1920*600</span>
            <el-upload
              class="avatar-uploader"
              accept="image/*"
              action=""
              multiple
              :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="config.urlStr + '/' + imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </div>
          <div class="item">
            <span class="left-label">实习双选会手机海报<br/>图片建议尺寸750*350</span>
            <el-upload
              class="avatar-uploader"
              accept="image/*"
              action=""
              multiple
              :show-file-list="false"
              :before-upload="beforeAvatarUpload2">
              <img v-if="imageUrl2" :src="config.urlStr + '/' + imageUrl2" class="avatar3">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </div>
        </div>
        <el-button type="primary" style="display: block;width: 200px;margin: 50px auto;" @click="save()">保存
        </el-button>
      </div>
    </div>
    <footerBox class="footer"/>

  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  import quill from '../../../../components/quill'
  import config from "../../../../config";

  export default {
    data() {
      return {
        config: config,
        name: '',
        imageUrl: '',
        imageUrl2: '',
        desc:'',
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {

      this.$emit('setType', 1);
    },
    methods: {
      // 获取内容
      getData(data) {
        this.desc = data
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload2(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl2 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      save(){
        this.$api.apiContent.addCustomSXH2({
          adminId:this.$store.state.user.id,
          sxhId:'',
          name:this.name,
          pc_image:this.imageUrl,
          web_image:this.imageUrl2,
          describe:this.desc
        }).then(()=>{
          this.$message.success('创建成功')
          this.$router.push('/home/meetAdmin/meetList2')
        }).catch(e=>{
          this.$message.error(e.info)
        })
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch: {},
    components: {
      footerBox,
      quill
    }
  }
</script>

<style scoped lang="scss">
  .gw-info-box {

    padding: 50px;
    margin: 0 auto;

  }

  .bannet-list-box {
    margin-bottom: 20px;


    .banner-item {
      /*display: flex;*/
      /*align-items: center;*/
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .left-label {
          display: block;
          width: 150px;
          text-align: center;
          line-height: 40px;
        }
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 960px;
    height: 250px;
    line-height: 250px;
    text-align: center;
    border: 1px dashed #8c939d;
  }

  .avatar {
    width: 960px;
    height: 250px;
    display: block;
  }

  .avatar3 {
    width: 750px;
    height: 350px;
    display: block;
  }

  .bannet-list-boxh5 .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 394px;
    height: 140px;
    line-height: 140px;
    text-align: center;
    border: 1px dashed #8c939d;
  }

  .bannet-list-boxh5 .avatar {
    width: 394px;
    height: 140px;
    display: block;
  }

  .bannet-list-boxh5 .avatar3 {
    width: 394px;
    height: 100px;
    display: block;
  }
</style>